import Timeline from './Timeline';
export default Timeline;


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/node_modules/_antd@3.0.0-beta.7@antd/es/timeline/index.js
// module id = 699
// module chunks = 0